module.exports = __webpack_public_path__ + "img/slide1-ru.ecc05fa9.png";